module.exports = __webpack_public_path__ + "static/media/integrations.1dc08d25.png";


//////////////////
// WEBPACK FOOTER
// ./src/admin/assets/img/integrations.png
// module id = 1120
// module chunks = 0